import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpPaths } from "src/app/core/constants/http-paths";
import { CommonHttpService } from "src/app/core/services/shared/common-http.service";
import { IResponse } from 'src/app/shared/models/iresponse.interface';
import { IGetAllWorkOrder, ILastWorkOrder } from 'src/app/core/models/facility/maintenance/workorder/getallworkorder.interface';
import { ICreateWorkOrder } from 'src/app/core/models/facility/maintenance/workorder/icreateworkorder.interface';
import { IWorkorder } from 'src/app/core/models/facility/maintenance/workorder/iworkorderprofile.interface';
import { WorkorderUtilityService } from "./Workorder-Utility.service";

@Injectable({
  providedIn: 'root',
})
export class WorkorderService {
  constructor(
    private readonly httpServive: CommonHttpService,
    public readonly utility: WorkorderUtilityService
  ) { }

  addWorkOrder(model: ICreateWorkOrder): Observable<IResponse<any>> {
    return this.httpServive.CommonPostRequests(
      model,
      `${localStorage.getItem('companyLink')}${HttpPaths.API_ADD_WORK_ORDER}`
    );
  }

  uploadFiles(formData: FormData): Observable<IResponse<any>> {
    return this.httpServive.CommonPostRequests(
      formData,
      `${localStorage.getItem('companyLink')}${HttpPaths.API_UPLOAD_FILES_FOR_SERVICE_REQUEST
      }`
    );
  }

  uploadFile(formData: FormData): Observable<IResponse<any>> {
    return this.httpServive.CommonPostRequests(
      formData,
      `${localStorage.getItem('companyLink')}${HttpPaths.API_UPLOAD_FILE_FOR_WORK_ORDER
      }`
    );
  }

  getWorkorderProfileById(
    workorderId: number
  ): Observable<IResponse<IWorkorder>> {
    return this.httpServive.CommonGetRequests(
      `${localStorage.getItem('companyLink')}${HttpPaths.API_GET_WORKORDER_PROFILE_BY_ID
      }${workorderId}`
    );
  }

  getWorkOrdersByVendorId(searchModel: any): Observable<IResponse<IGetAllWorkOrder[]>> {
    return this.httpServive.CommonGetRequestsWithQuery(`${localStorage.getItem('companyLink')}${HttpPaths.API_GET_WORK_ORDER_BY_VENDOR_ID}`, searchModel);
  }

  getWorkOrdersByAssetId(
    searchModel: any
  ): Observable<IResponse<ILastWorkOrder[]>> {
    return this.httpServive.CommonGetRequestsWithQuery(
      `${localStorage.getItem('companyLink')}${HttpPaths.API_GET_WORK_ORDER_BY_ASSET_ID
      }`,
      searchModel
    );
  }

  changeAssignWorkOrder(model: any): Observable<IResponse<any>> {
    return this.httpServive.CommonPostRequests(
      model,
      `${localStorage.getItem('companyLink')}${HttpPaths.API_REASSIGN_WORK_ORDER
      }`
    );
  }

  rejectWorkOrder(model: any): Observable<IResponse<any>> {
    return this.httpServive.CommonPutRequests(
      model,
      `${localStorage.getItem('companyLink')}${HttpPaths.API_REJECTED_WORK_ORDER
      }`
    );
  }

  closeWorkOrder(model: any): Observable<IResponse<any>> {
    return this.httpServive.CommonPostRequests(
      model,
      `${localStorage.getItem('companyLink')}${HttpPaths.API_POST_CLOSE_WORK_ORDER
      }`
    );
  }

  getAllCalenderData(model: any) {
    return this.httpServive.CommonGetRequestsWithQuery(
      `${localStorage.getItem('companyLink')}${HttpPaths.API_GET_All_CALENDER}`,
      model
    );
  }

  
  getCalenderData(model: any): Observable<IResponse<any>> {
    return this.httpServive.CommonPostRequests(
      model,
      `${localStorage.getItem('companyLink')}${HttpPaths.API_GET_CALENDER}`
    );
  }

  getAllWorkorder(searchModel:any){
    return this.httpServive.CommonGetRequestsWithQuery(`${localStorage.getItem('companyLink')}${HttpPaths.API_GET_ALL_WORK_ORDER_VENDOR}`,searchModel)
  }

  changeWFSForWorkOrder(model: any): Observable<IResponse<any>> {
    return this.httpServive.CommonPostRequests(model,`${localStorage.getItem('companyLink')}${HttpPaths.API_CHANGE_WFS_FOR_WORK_ORDER}`);
  }

    updateWorkOrder(model: any): Observable<IResponse<any>> {
    return this.httpServive.CommonPutRequests(model, `${localStorage.getItem('companyLink')}${HttpPaths.API_UPDATE_WORK_ORDER}`);
  }

}
